<template>
  <pt-sell-operate-choice-dialog class="pt-sell-operate-choice-dialog__withData"></pt-sell-operate-choice-dialog>
</template>

<script>
import PtSellOperateChoiceDialog from './index'
export default {
  name: 'pt-sell-operate-choice-dialog__withData',
  components: {
    'pt-sell-operate-choice-dialog': PtSellOperateChoiceDialog
  }
}
</script>
